module.exports = __webpack_public_path__ + "img/symbol_questionblack.e1568ed6.png";